import type { ResidentItem } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useCallback } from 'react'
import { useQuery, useQueryClient } from 'react-query'

export const GET_RESIDENTS = `/api/list/residents?anyStatus=true`

/**
 * use useResidentsList instead
 * @deprecated
 */
const useResidents = () => {
  const queryClient = useQueryClient()

  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-existing dependency list; changing when this re-runs needs behavioural review
  const onSuccess = useCallback((data: { result: ResidentItem[] }) => {
    const residents = data.result

    residents.forEach((resident) => {
      queryClient.setQueryData(['resident', resident.id], {
        result: resident
      })
    })
  }, [])

  const { isLoading, data, refetch } = useQuery<{ result: ResidentItem[] }>(
    'residents',
    () => getJSON({ url: GET_RESIDENTS }),
    {
      onSuccess
    }
  )

  return {
    isLoading,
    residents: data?.result || [],
    fetchCarers: refetch
  }
}

export default useResidents
